export const TypeConstant = {
    Name: 'NAME',
    Email: 'EMAIL',
    JobTitle: 'JOBTITLE',
    Department:'DEPARTMENT',
    Mobile:'MOBILE',
    WebSite:'WEBSITE',

    Image:'IMAGE',
    ShowAiYearLogo:'SHOW_AI_YEAR_LOGO',

    Ar_Name: 'AR_NAME',
    Ar_JobTitle: 'AR_JOBTITLE',
    Ar_Department:'AR_DEPARTMENT',
    Ar_Email: 'AR_EMAIL',
    Ar_Mobile: 'AR_MOBILE',
    Ar_Website:'AR_WEBSITE',

    Linkedin: 'LINKEDIN',
    Twitter:'TWITTER',
    Facebook:'FACEBOOK',
    Github:'GITHUB',

    English:"en",
    Arabic:"ar",

    Language:'ar',

    IsMounted:false,
}
